import React from 'react'

const Footer = () => {
  return(
  <footer>
    <p>Copyright © 2021 jaguilarweb. All rights reserved.</p>
  </footer>)
}

export default Footer
